/* Quorvex: reveal-on-scroll and split-line headings. No dependencies. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        // Also reveal anything already scrolled past (fast jumps, anchors, back navigation).
        if (!entry.isIntersecting && entry.boundingClientRect.bottom > 0) continue;
        const target = proxies.get(entry.target) || entry.target;
        target.classList.add('is-in');
        pending.delete(target);
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -40px 0px', threshold: 0.01 }
  );

  // A clip-path hides the element from IntersectionObserver, so mask reveals watch their parent.
  const proxies = new WeakMap();
  const pending = new Set();

  // IntersectionObserver misses elements that a fast jump skips over; catch them on scroll.
  let ticking = false;
  const sweep = () => {
    ticking = false;
    for (const el of pending) {
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('is-in');
        pending.delete(el);
      }
    }
  };
  const onScroll = () => {
    if (ticking || pending.size === 0) return;
    ticking = true;
    requestAnimationFrame(sweep);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });

  const watch = (root = document) => {
    root.querySelectorAll('[data-q-reveal]:not(.is-in):not([data-q-seen]), .q-lines:not(.is-in):not([data-q-seen])').forEach((el) => {
      el.setAttribute('data-q-seen', '');
      if (reduce.matches) {
        el.classList.add('is-in');
        return;
      }
      pending.add(el);
      const mask = (el.getAttribute('data-q-reveal') || '').startsWith('mask');
      if (mask && el.parentElement) {
        proxies.set(el.parentElement, el);
        observer.observe(el.parentElement);
      } else {
        observer.observe(el);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => watch());
  } else {
    watch();
  }

  // Theme editor reloads and Horizon's DOM morphing can swap nodes; watch anything new.
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (node.matches('[data-q-reveal], .q-lines') || node.querySelector('[data-q-reveal], .q-lines'))) {
          watch(node.parentNode || document);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.Quorvex = Object.assign(window.Quorvex || {}, { watch });
})();
